"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    Icon: undefined,
    title: '',
    children: undefined,
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map